import React from 'react';

export interface ServiceCardProps {
  title: string;
  value: string;
  description: string;
  icon: React.ReactNode;
}

export interface VettingStep {
  number: string;
  title: string;
  description: string;
}

export enum AppSection {
  Home = 'home',
  Solutions = 'solutions',
  Talent = 'talent',
  CaseStudies = 'case-studies',
  About = 'about'
}